import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select/async';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import { CustomSelect } from './style';
import {
    ClearIndicator,
    getCommonStyles,
    getDropdownIndicator,
    getMultiSelectStyles,
    MultiValueLabel,
    MultiValueRemove,
    SingleValue,
} from './utils';

function CanopySearch({ width = '100%', components, styles, ...props }: any) {
    const { t } = useTranslation();
    const currentColors = useCurrentColors();

    return (
        <Box width={width}>
            <Box>
                <CustomSelect
                    $currentColors={currentColors}
                    $styleProps={props}
                >
                    <Select
                        menuPortalTarget={
                            (window as any).skeleton
                                ? document.querySelector('skeleton-nav')
                                : document.body
                        }
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        classNamePrefix="react-select"
                        noOptionsMessage={(option: any) =>
                            !option.inputValue
                                ? t('type-to-search')
                                : t('ui.mm.filter.no-options')
                        }
                        styles={
                            props?.isMulti
                                ? {
                                      ...getMultiSelectStyles(
                                          currentColors,
                                          props
                                      ),
                                      ...styles,
                                  }
                                : {
                                      ...getCommonStyles(currentColors, props),
                                      ...styles,
                                  }
                        }
                        components={{
                            MultiValueLabel,
                            MultiValueRemove,
                            SingleValue,
                            DropdownIndicator:
                                getDropdownIndicator(currentColors),
                            ClearIndicator,
                            ...components,
                        }}
                        isClearable={true}
                        {...props}
                    />
                </CustomSelect>
            </Box>
        </Box>
    );
}

export default CanopySearch;
